import { getDecodedConsulData } from '@shared/lib/consul'
import { PriorityListItemType } from '../model/tsp.types'

export const fetchPriorityList = async () => {
  try {
    return await getDecodedConsulData<{
      priorityServices: PriorityListItemType[]
      topPriorityServices: PriorityListItemType[]
    }>('/services/priority-services/value')
  } catch (error) {
    console.error('fetchPriorityList:', error)

    return { priorityServices: [], topPriorityServices: [] }
  }
}
